var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.777778 0H13.2222C13.4285 0 13.6263 0.0819442 13.7722 0.227806C13.9181 0.373667 14 0.571498 14 0.777778V7L10.1111 10.8889H5.44444L2.33333 14V10.8889H0.777778C0.571498 10.8889 0.373667 10.8069 0.227806 10.6611C0.0819442 10.5152 0 10.3174 0 10.1111V0.777778C0 0.571498 0.0819442 0.373667 0.227806 0.227806C0.373667 0.0819442 0.571498 0 0.777778 0Z",
    fill: "#23F6CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 3.88892V7.00003V3.88892ZM9.33335 3.88892V7.00003V3.88892Z",
    fill: "#23F6CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 3.88892V7.00003M9.33335 3.88892V7.00003",
    stroke: "#190918",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchLogo);
export default __webpack_public_path__ + "static/media/twitch_logo.6b6c68873764b8aefba3be88d20f6ca5.svg";
export { ForwardRef as ReactComponent };